import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "./NcdForm.css";
import { validateForm } from "../../../utils/validationUtils";
import { Form } from 'react-bootstrap';
import { ncdAPI } from "../../../services/ncd.api";
import { useNCD } from "../hooks/useNCD";

export const Personalhistory = ({ individualId, viewMode, gender, selectedUser,setUserError }) => {

    const { screeningData, setLoading, setScreeningData, setError, clearScreeningData } = useNCD();
    const [formErrors, setFormErrors] = useState({});
    const personalhistory = screeningData[`personalHistory_${individualId}`];
    const menstrualHistory = screeningData[`menstrualHistory_${individualId}`];

    const [perhistoryform, setPerHistoryform] = useState({
        isHypertension: null,
        isDiabetes: null,
        isHeartDiseases: null,
        isHeartDiseasesUnderTreatment: null,
        isStroke: null,
        isStrokeUnderTreatment: null,
        isKidneyFailure: null,
        isKidneyFailureUnderTreatment: null,
        isNonHealingWounds: null,
        isNonHealingWoundsUnderTreatment: null,
        isCopd: null,
        isCopdUnderTreatment: null,
        isAsthma: null,
        isAsthmaUnderTreatment: null,
        isOralCancer: null,
        isOralCancerUnderTreatment: null,
        isBreastCancer: null,
        isBreastCancerUnderTreatment: null,
        isCervicalCancer: null,
        isCervicalCancerUnderTreatment: null,
        otherDiseaseDetails: null,
        isOtherDisease: null,
        isOtherDiseaseUnderTreatment: null,
        isHypertensionUnderTreatment: null,
        isDiabetesUnderTreatment: null
    });

    const [menstrualForm, setMenstrualForm] = useState({
        isMenopause: null,
        menopauseDuration: null,
        isPregnant: null,
        menarcheAge: "",
        isLactating: null,
        lastMenstrualDate: null,
        isRegularPeriods: null,
        isBleedingWithPain: null,
        isBleedingWithClots: null,
        remarks: "",
        menstrualBleedingType: "",
        menopauseDurationYear: "",
        menopauseDurationMonth: "",
        createdUser: selectedUser || ""
    });

    useEffect(() => {

        const fetchPersonalHistory = async () => {
            try {
                if (!individualId) return;

                setLoading(true);
                const [fetchedValue, menstrHistory] = await Promise.all([
                    ncdAPI.getPersonalHistory(individualId),
                    ncdAPI.getMenstrualHistory(individualId)
                ]);

                setScreeningData(`personalHistory_${individualId}`, fetchedValue.data);
                setScreeningData(`menstrualHistory_${individualId}`, menstrHistory.data);
                setLoading(false);
            } catch (error) {
                setError("Error fetching personal history data");
                setLoading(false);
            }
        };

        if (viewMode === 'VIEW' && !personalhistory) {
            fetchPersonalHistory();
        } else {
            setLoading(false);
        }

    }, [individualId, viewMode]);

    // Handle form input changes
    const handleperhistory = (e) => {
        const { name, value } = e.target;
        const newValue = value === "yes" ? true : value === "no" ? false : value;

        let updatedForm = {
            ...perhistoryform,
            [name]: newValue,
        };

        // Clear corresponding "Under Treatment" field when "Ever Diagnosed" is set to "No"
        if (newValue === false) {
            const treatmentFieldMap = {
                'isHypertension': 'isHypertensionUnderTreatment',
                'isDiabetes': 'isDiabetesUnderTreatment',
                'isHeartDiseases': 'isHeartDiseasesUnderTreatment',
                'isStroke': 'isStrokeUnderTreatment',
                'isKidneyFailure': 'isKidneyFailureUnderTreatment',
                'isNonHealingWounds': 'isNonHealingWoundsUnderTreatment',
                'isCopd': 'isCopdUnderTreatment',
                'isAsthma': 'isAsthmaUnderTreatment',
                'isOralCancer': 'isOralCancerUnderTreatment',
                'isBreastCancer': 'isBreastCancerUnderTreatment',
                'isCervicalCancer': 'isCervicalCancerUnderTreatment',
                'isOtherDisease': 'isOtherDiseaseUnderTreatment'
            };

            const treatmentField = treatmentFieldMap[name];
            if (treatmentField) {
                updatedForm[treatmentField] = null;
            }
        }

        // Clear isOtherDisease and isOtherDiseaseUnderTreatment when otherDiseaseDetails is empty
        if (name === 'otherDiseaseDetails' && !newValue?.trim()) {
            updatedForm.isOtherDisease = null;
            updatedForm.isOtherDiseaseUnderTreatment = null;
        }

        setPerHistoryform(updatedForm);
        setFormErrors({ ...formErrors, [name]: "" });
    };

    const handleMenstrualChange = (e) => {
        const { name, value, type, checked } = e.target;

        let newValue;
        if (name === "lastMenstrualDate" && value) {
            const [yyyy, mm, dd] = value.split("-");
            newValue = `${dd}-${mm}-${yyyy}`;
        } else {
            newValue =
                type === "checkbox"
                    ? checked
                    : value === "yes"
                        ? true
                        : value === "no"
                            ? false
                            : value;
        }

        setMenstrualForm(prev => {
            let updated = { ...prev, [name]: newValue };
            // If Menopause is changed, reset/disable other fields as needed
            if (name === "isMenopause") {
                if (newValue === true) {
                    // Enable only menopauseDuration, disable others except remarks and menarcheAge
                    updated = {
                        ...updated,
                        menopauseDurationYear: prev.menopauseDurationYear,
                        menopauseDurationMonth: prev.menopauseDurationMonth,
                        isPregnant: null,
                        isLactating: null,
                        isRegularPeriods: null,
                        lastMenstrualDate: null,
                        isBleedingWithPain: null,
                        isBleedingWithClots: null,
                        menstrualBleedingType: "",
                    };
                } else if (newValue === false) {
                    // Enable all except menopauseDuration
                    updated = {
                        ...updated,
                        menopauseDurationYear: "",
                        menopauseDurationMonth: "",
                    };
                }
            }
            // If Pregnant is changed, disable all except menarcheAge, remarks, and lactating
            if (name === "isPregnant") {
                if (newValue === true) {
                    updated = {
                        ...updated,
                        isMenopause: null,
                        menopauseDurationYear: "",
                        menopauseDurationMonth: "",
                        isRegularPeriods: null,
                        lastMenstrualDate: null,
                        isBleedingWithPain: null,
                        isBleedingWithClots: null,
                        menstrualBleedingType: "",
                        // keep isLactating, menarcheAge, remarks as is
                    };
                }
            }
            return updated;
        });
    };

    const perHistorySchema = {
        isHypertension: {
            customValidator: (value) => {
                if (value !== true && value !== false) {
                    return "This field is required.";
                }
                return null;
            }
        },
        isHypertensionUnderTreatment: {
            customValidator: (value, values) => {
                if (values.isHypertension === true && (value !== true && value !== false)) {
                    return "This field is required.";
                }
                return null;
            }
        },
        isDiabetes: {
            customValidator: (value) => {
                if (value !== true && value !== false) {
                    return "This field is required.";
                }
                return null;
            }
        },
        isDiabetesUnderTreatment: {
            customValidator: (value, values) => {
                if (values.isDiabetes === true && (value !== true && value !== false)) {
                    return "This field is required.";
                }
                return null;
            }
        },
        isHeartDiseases: {
            customValidator: (value) => {
                if (value !== true && value !== false) {
                    return "This field is required.";
                }
                return null;
            }
        },
        isHeartDiseasesUnderTreatment: {
            customValidator: (value, values) => {
                if (values.isHeartDiseases === true && (value !== true && value !== false)) {
                    return "This field is required.";
                }
                return null;
            }
        },
        isStroke: {
            customValidator: (value) => {
                if (value !== true && value !== false) {
                    return "This field is required.";
                }
                return null;
            }
        },
        isStrokeUnderTreatment: {
            customValidator: (value, values) => {
                if (values.isStroke === true && (value !== true && value !== false)) {
                    return "This field is required.";
                }
                return null;
            }
        },
        isKidneyFailure: {
            customValidator: (value) => {
                if (value !== true && value !== false) {
                    return "This field is required.";
                }
                return null;
            }
        },
        isKidneyFailureUnderTreatment: {
            customValidator: (value, values) => {
                if (values.isKidneyFailure === true && (value !== true && value !== false)) {
                    return "This field is required.";
                }
                return null;
            }
        },
        isNonHealingWounds: {
            customValidator: (value) => {
                if (value !== true && value !== false) {
                    return "This field is required.";
                }
                return null;
            }
        },
        isNonHealingWoundsUnderTreatment: {
            customValidator: (value, values) => {
                if (values.isNonHealingWounds === true && (value !== true && value !== false)) {
                    return "This field is required.";
                }
                return null;
            }
        },
        isCopd: {
            customValidator: (value) => {
                if (value !== true && value !== false) {
                    return "This field is required.";
                }
                return null;
            }
        },
        isCopdUnderTreatment: {
            customValidator: (value, values) => {
                if (values.isCopd === true && (value !== true && value !== false)) {
                    return "This field is required.";
                }
                return null;
            }
        },
        isAsthma: {
            customValidator: (value) => {
                if (value !== true && value !== false) {
                    return "This field is required.";
                }
                return null;
            }
        },
        isAsthmaUnderTreatment: {
            customValidator: (value, values) => {
                if (values.isAsthma === true && (value !== true && value !== false)) {
                    return "This field is required.";
                }
                return null;
            }
        },
        isOralCancer: {
            customValidator: (value) => {
                if (value !== true && value !== false) {
                    return "This field is required.";
                }
                return null;
            }
        },
        isOralCancerUnderTreatment: {
            customValidator: (value, values) => {
                if (values.isOralCancer === true && (value !== true && value !== false)) {
                    return "This field is required.";
                }
                return null;
            }
        },
        isOtherDisease: {
            customValidator: (value, values) => {
                if (values.otherDiseaseDetails?.trim() && value !== true && value !== false) {
                    return "This field is required.";
                }
                return null;
            }
        },
        isOtherDiseaseUnderTreatment: {
            customValidator: (value, values) => {
                if (values.isOtherDisease === true && (value !== true && value !== false)) {
                    return "This field is required.";
                }
                return null;
            }
        },
    };

    const perHistorySubmit = async (e) => {
        e.preventDefault();

        const errors = validateForm(perhistoryform, perHistorySchema);
        // If there are errors, update state and do not submit
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }

         if (!selectedUser) {
            setUserError(true);
            toast.error("Please select SHC staff", { className: "custom-toast-error" });
            return false;
        }

        try {
            setLoading(true);


            const payload = {
                ...perhistoryform,
                createdUser: selectedUser
            };

            // Submit personal history
            const response = await ncdAPI.submitPersonalHistory(individualId, payload);
            let responsemenstrual;

            // Submit menstrual history if female
            if (gender?.toLowerCase() === 'female') {
                let menopauseDuration = "";
                if (menstrualForm.menopauseDurationYear || menstrualForm.menopauseDurationMonth) {
                    const years = menstrualForm.menopauseDurationYear || "0";
                    const months = menstrualForm.menopauseDurationMonth || "0";
                    menopauseDuration = `${years} Years, ${months} Months`;
                }
                const menstrualPayload = {
                    isMenopause: menstrualForm.isMenopause,
                    menopauseDuration: menopauseDuration,
                    isPregnant: menstrualForm.isPregnant,
                    menarcheAge: menstrualForm.menarcheAge,
                    isLactating: menstrualForm.isLactating,
                    lastMenstrualDate: menstrualForm.lastMenstrualDate,
                    isRegularPeriods: menstrualForm.isRegularPeriods,
                    isBleedingWithPain: menstrualForm.isBleedingWithPain,
                    isBleedingWithClots: menstrualForm.isBleedingWithClots,
                    remarks: menstrualForm.remarks,
                    isMenstrualBleedingHeavy: menstrualForm.menstrualBleedingType === "heavy",
                    isMenstrualBleedingNormal: menstrualForm.menstrualBleedingType === "normal",
                    createdUser: selectedUser
                };

                responsemenstrual = await ncdAPI.submitMenstrualHistory(individualId, menstrualPayload);
            }

            if (response.success || (typeof responsemenstrual !== "undefined" && responsemenstrual === true)) {

                toast.success(`Personal history saved successfully`);
                
                clearScreeningData(`personalHistory_${individualId}`);
                clearScreeningData(`menstrualHistory_${individualId}`);

                // Reset forms
                setPerHistoryform({
                    isHypertension: null,
                    isDiabetes: null,
                    isHeartDiseases: null,
                    isHeartDiseasesUnderTreatment: null,
                    isStroke: null,
                    isStrokeUnderTreatment: null,
                    isKidneyFailure: null,
                    isKidneyFailureUnderTreatment: null,
                    isNonHealingWounds: null,
                    isNonHealingWoundsUnderTreatment: null,
                    isCopd: null,
                    isCopdUnderTreatment: null,
                    isAsthma: null,
                    isAsthmaUnderTreatment: null,
                    isOralCancer: null,
                    isOralCancerUnderTreatment: null,
                    isBreastCancer: null,
                    isBreastCancerUnderTreatment: null,
                    isCervicalCancer: null,
                    isCervicalCancerUnderTreatment: null,
                    otherDiseaseDetails: null,
                    isOtherDisease: null,
                    isOtherDiseaseUnderTreatment: null,
                    isHypertensionUnderTreatment: null,
                    isDiabetesUnderTreatment: null
                });

                if (gender?.toLowerCase() === 'female') {
                    setMenstrualForm({
                        isMenopause: null,
                        menopauseDuration: null,
                        isPregnant: null,
                        menarcheAge: "",
                        isLactating: null,
                        lastMenstrualDate: null,
                        isRegularPeriods: null,
                        isBleedingWithPain: null,
                        isBleedingWithClots: null,
                        remarks: "",
                        menstrualBleedingType: "",
                        menopauseDurationYear: "",
                        menopauseDurationMonth: ""
                    });
                }

                setFormErrors({});

            } else {
                toast.error(
                    (response && response.message) ||
                    (responsemenstrual && responsemenstrual.message) ||
                    "Failed to save data",
                    { className: "custom-toast-error" }
                );
            }
            setLoading(false);
        } catch (error) {
            toast.error(error.response?.data?.message || "Something went wrong", { className: "custom-toast-error" });
            setLoading(false);
        }
    };

    return (
        <>

            <div className="personal-history-table">

                {viewMode === "ADD" ? (
                    <div className="table-responsive">
                        <form onSubmit={perHistorySubmit}>
                            <table className="table custom-striped custom-table">
                                <thead className="table-head">
                                    <tr>
                                        <th>Disease</th>
                                        <th>Ever Diagnosed</th>
                                        <th>Under Treatment</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Hypertension </td>
                                        <td className="radio_color">
                                            <input type="radio" name="isHypertension" id="isHypertensionYes" value="yes" checked={perhistoryform.isHypertension === true} onChange={handleperhistory} className="form-check-input" />
                                            <label className="form-check-label mr-20" htmlFor="isHypertensionYes">Yes</label>
                                            <input type="radio" name="isHypertension" id="isHypertensionNo" value="no" checked={perhistoryform.isHypertension === false} onChange={handleperhistory} className="form-check-input" />
                                            <label className="form-check-label" htmlFor="isHypertensionNo">No</label>
                                            {formErrors.isHypertension && <p className="error">{formErrors.isHypertension}</p>}
                                        </td>
                                        <td className="radio_color">
                                            <input type="radio" name="isHypertensionUnderTreatment" id="isHypertensionUnderTreatmentYes" value="yes" checked={perhistoryform.isHypertensionUnderTreatment === true} onChange={handleperhistory} disabled={!perhistoryform.isHypertension} className="form-check-input" />
                                            <label className="form-check-label mr-20" htmlFor="isHypertensionUnderTreatmentYes">Yes</label>
                                            <input type="radio" name="isHypertensionUnderTreatment" id="isHypertensionUnderTreatmentNo" value="no" checked={perhistoryform.isHypertensionUnderTreatment === false} onChange={handleperhistory} disabled={!perhistoryform.isHypertension} className="form-check-input" />
                                            <label className="form-check-label" htmlFor="isHypertensionUnderTreatmentNo">No</label>
                                            {formErrors.isHypertensionUnderTreatment && <p className="error">{formErrors.isHypertensionUnderTreatment}</p>}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Diabetes </td>
                                        <td className="radio_color">
                                            <input type="radio" name="isDiabetes" id="isDiabetesYes" value="yes" checked={perhistoryform.isDiabetes === true} onChange={handleperhistory} className="form-check-input" />
                                            <label className="form-check-label mr-20" htmlFor="isDiabetesYes">Yes</label>
                                            <input type="radio" name="isDiabetes" id="isDiabetesNo" value="no" checked={perhistoryform.isDiabetes === false} onChange={handleperhistory} className="form-check-input" />
                                            <label className="form-check-label" htmlFor="isDiabetesNo">No</label>
                                            {formErrors.isDiabetes && <p className="error">{formErrors.isDiabetes}</p>}
                                        </td>
                                        <td className="radio_color">
                                            <input type="radio" name="isDiabetesUnderTreatment" id="isDiabetesUnderTreatmentYes" value="yes" checked={perhistoryform.isDiabetesUnderTreatment === true} onChange={handleperhistory} disabled={!perhistoryform.isDiabetes} className="form-check-input" />
                                            <label className="form-check-label mr-20" htmlFor="isDiabetesUnderTreatmentYes">Yes</label>
                                            <input type="radio" name="isDiabetesUnderTreatment" id="isDiabetesUnderTreatmentNo" value="no" checked={perhistoryform.isDiabetesUnderTreatment === false} onChange={handleperhistory} disabled={!perhistoryform.isDiabetes} className="form-check-input" />
                                            <label className="form-check-label" htmlFor="isDiabetesUnderTreatmentNo">No</label>
                                            {formErrors.isDiabetesUnderTreatment && <p className="error">{formErrors.isDiabetesUnderTreatment}</p>}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Heart Disease </td>
                                        <td className="radio_color">
                                            <input type="radio" name="isHeartDiseases" id="isHeartDiseasesYes" value="yes" checked={perhistoryform.isHeartDiseases === true} onChange={handleperhistory} className="form-check-input" />
                                            <label className="form-check-label mr-20" htmlFor="isHeartDiseasesYes">Yes</label>
                                            <input type="radio" name="isHeartDiseases" id="isHeartDiseasesNo" value="no" checked={perhistoryform.isHeartDiseases === false} onChange={handleperhistory} className="form-check-input" />
                                            <label className="form-check-label" htmlFor="isHeartDiseasesNo">No</label>
                                            {formErrors.isHeartDiseases && <p className="error">{formErrors.isHeartDiseases}</p>}
                                        </td>
                                        <td className="radio_color">
                                            <input type="radio" name="isHeartDiseasesUnderTreatment" id="isHeartDiseasesUnderTreatmentYes" value="yes" checked={perhistoryform.isHeartDiseasesUnderTreatment === true} onChange={handleperhistory} disabled={!perhistoryform.isHeartDiseases} className="form-check-input" />
                                            <label className="form-check-label mr-20" htmlFor="isHeartDiseasesUnderTreatmentYes">Yes</label>
                                            <input type="radio" name="isHeartDiseasesUnderTreatment" id="isHeartDiseasesUnderTreatmentNo" value="no" checked={perhistoryform.isHeartDiseasesUnderTreatment === false} onChange={handleperhistory} disabled={!perhistoryform.isHeartDiseases} className="form-check-input" />
                                            <label className="form-check-label" htmlFor="isHeartDiseasesUnderTreatmentNo">No</label>
                                            {formErrors.isHeartDiseasesUnderTreatment && <p className="error">{formErrors.isHeartDiseasesUnderTreatment}</p>}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Stroke </td>
                                        <td className="radio_color">
                                            <input type="radio" name="isStroke" id="isStrokeYes" value="yes" checked={perhistoryform.isStroke === true} onChange={handleperhistory} className="form-check-input" />
                                            <label className="form-check-label mr-20" htmlFor="isStrokeYes">Yes</label>
                                            <input type="radio" name="isStroke" id="isStrokeNo" value="no" checked={perhistoryform.isStroke === false} onChange={handleperhistory} className="form-check-input" />
                                            <label className="form-check-label" htmlFor="isStrokeNo">No</label>
                                            {formErrors.isStroke && <p className="error">{formErrors.isStroke}</p>}
                                        </td>
                                        <td className="radio_color">
                                            <input type="radio" name="isStrokeUnderTreatment" id="isStrokeUnderTreatmentYes" value="yes" checked={perhistoryform.isStrokeUnderTreatment === true} onChange={handleperhistory} disabled={!perhistoryform.isStroke} className="form-check-input" />
                                            <label className="form-check-label mr-20" htmlFor="isStrokeUnderTreatmentYes">Yes</label>
                                            <input type="radio" name="isStrokeUnderTreatment" id="isStrokeUnderTreatmentNo" value="no" checked={perhistoryform.isStrokeUnderTreatment === false} onChange={handleperhistory} disabled={!perhistoryform.isStroke} className="form-check-input" />
                                            <label className="form-check-label" htmlFor="isStrokeUnderTreatmentNo">No</label>
                                            {formErrors.isStrokeUnderTreatment && <p className="error">{formErrors.isStrokeUnderTreatment}</p>}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Kidney failure </td>
                                        <td className="radio_color">
                                            <input type="radio" name="isKidneyFailure" id="isKidneyFailureYes" value="yes" checked={perhistoryform.isKidneyFailure === true} onChange={handleperhistory} className="form-check-input" />
                                            <label className="form-check-label mr-20" htmlFor="isKidneyFailureYes">Yes</label>
                                            <input type="radio" name="isKidneyFailure" id="isKidneyFailureNo" value="no" checked={perhistoryform.isKidneyFailure === false} onChange={handleperhistory} className="form-check-input" />
                                            <label className="form-check-label" htmlFor="isKidneyFailureNo">No</label>
                                            {formErrors.isKidneyFailure && <p className="error">{formErrors.isKidneyFailure}</p>}
                                        </td>
                                        <td className="radio_color">
                                            <input type="radio" name="isKidneyFailureUnderTreatment" id="isKidneyFailureUnderTreatmentYes" value="yes" checked={perhistoryform.isKidneyFailureUnderTreatment === true} onChange={handleperhistory} disabled={!perhistoryform.isKidneyFailure} className="form-check-input" />
                                            <label className="form-check-label mr-20" htmlFor="isKidneyFailureUnderTreatmentYes">Yes</label>
                                            <input type="radio" name="isKidneyFailureUnderTreatment" id="isKidneyFailureUnderTreatmentNo" value="no" checked={perhistoryform.isKidneyFailureUnderTreatment === false} onChange={handleperhistory} disabled={!perhistoryform.isKidneyFailure} className="form-check-input" />
                                            <label className="form-check-label" htmlFor="isKidneyFailureUnderTreatmentNo">No</label>
                                            {formErrors.isKidneyFailureUnderTreatment && <p className="error">{formErrors.isKidneyFailureUnderTreatment}</p>}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Non-healing Wound </td>
                                        <td className="radio_color">
                                            <input type="radio" name="isNonHealingWounds" id="isNonHealingWoundsYes" value="yes" checked={perhistoryform.isNonHealingWounds === true} onChange={handleperhistory} className="form-check-input" />
                                            <label className="form-check-label mr-20" htmlFor="isNonHealingWoundsYes">Yes</label>
                                            <input type="radio" name="isNonHealingWounds" id="isNonHealingWoundsNo" value="no" checked={perhistoryform.isNonHealingWounds === false} onChange={handleperhistory} className="form-check-input" />
                                            <label className="form-check-label" htmlFor="isNonHealingWoundsNo">No</label>
                                            {formErrors.isNonHealingWounds && <p className="error">{formErrors.isNonHealingWounds}</p>}
                                        </td>
                                        <td className="radio_color">
                                            <input type="radio" name="isNonHealingWoundsUnderTreatment" id="isNonHealingWoundsUnderTreatmentYes" value="yes" checked={perhistoryform.isNonHealingWoundsUnderTreatment === true} onChange={handleperhistory} disabled={!perhistoryform.isNonHealingWounds} className="form-check-input" />
                                            <label className="form-check-label mr-20" htmlFor="isNonHealingWoundsUnderTreatmentYes">Yes</label>
                                            <input type="radio" name="isNonHealingWoundsUnderTreatment" id="isNonHealingWoundsUnderTreatmentNo" value="no" checked={perhistoryform.isNonHealingWoundsUnderTreatment === false} onChange={handleperhistory} disabled={!perhistoryform.isNonHealingWounds} className="form-check-input" />
                                            <label className="form-check-label" htmlFor="isNonHealingWoundsUnderTreatmentNo">No</label>
                                            {formErrors.isNonHealingWoundsUnderTreatment && <p className="error">{formErrors.isNonHealingWoundsUnderTreatment}</p>}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>COPD </td>
                                        <td className="radio_color">
                                            <input type="radio" name="isCopd" id="isCopdYes" value="yes" checked={perhistoryform.isCopd === true} onChange={handleperhistory} className="form-check-input" />
                                            <label className="form-check-label mr-20" htmlFor="isCopdYes">Yes</label>
                                            <input type="radio" name="isCopd" id="isCopdNo" value="no" checked={perhistoryform.isCopd === false} onChange={handleperhistory} className="form-check-input" />
                                            <label className="form-check-label" htmlFor="isCopdNo">No</label>
                                            {formErrors.isCopd && <p className="error">{formErrors.isCopd}</p>}
                                        </td>
                                        <td className="radio_color">
                                            <input type="radio" name="isCopdUnderTreatment" id="isCopdUnderTreatmentYes" value="yes" checked={perhistoryform.isCopdUnderTreatment === true} onChange={handleperhistory} disabled={!perhistoryform.isCopd} className="form-check-input" />
                                            <label className="form-check-label mr-20" htmlFor="isCopdUnderTreatmentYes">Yes</label>
                                            <input type="radio" name="isCopdUnderTreatment" id="isCopdUnderTreatmentNo" value="no" checked={perhistoryform.isCopdUnderTreatment === false} onChange={handleperhistory} disabled={!perhistoryform.isCopd} className="form-check-input" />
                                            <label className="form-check-label" htmlFor="isCopdUnderTreatmentNo">No</label>
                                            {formErrors.isCopdUnderTreatment && <p className="error">{formErrors.isCopdUnderTreatment}</p>}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Asthma </td>
                                        <td className="radio_color">
                                            <input type="radio" name="isAsthma" id="isAsthmaYes" value="yes" checked={perhistoryform.isAsthma === true} onChange={handleperhistory} className="form-check-input" />
                                            <label className="form-check-label mr-20" htmlFor="isAsthmaYes">Yes</label>
                                            <input type="radio" name="isAsthma" id="isAsthmaNo" value="no" checked={perhistoryform.isAsthma === false} onChange={handleperhistory} className="form-check-input" />
                                            <label className="form-check-label" htmlFor="isAsthmaNo">No</label>
                                            {formErrors.isAsthma && <p className="error">{formErrors.isAsthma}</p>}
                                        </td>
                                        <td className="radio_color">
                                            <input type="radio" name="isAsthmaUnderTreatment" id="isAsthmaUnderTreatmentYes" value="yes" checked={perhistoryform.isAsthmaUnderTreatment === true} onChange={handleperhistory} disabled={!perhistoryform.isAsthma} className="form-check-input" />
                                            <label className="form-check-label mr-20" htmlFor="isAsthmaUnderTreatmentYes">Yes</label>
                                            <input type="radio" name="isAsthmaUnderTreatment" id="isAsthmaUnderTreatmentNo" value="no" checked={perhistoryform.isAsthmaUnderTreatment === false} onChange={handleperhistory} disabled={!perhistoryform.isAsthma} className="form-check-input" />
                                            <label className="form-check-label" htmlFor="isAsthmaUnderTreatmentNo">No</label>
                                            {formErrors.isAsthmaUnderTreatment && <p className="error">{formErrors.isAsthmaUnderTreatment}</p>}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Oral Cancer </td>
                                        <td className="radio_color">
                                            <input type="radio" name="isOralCancer" id="isOralCancerYes" value="yes" checked={perhistoryform.isOralCancer === true} onChange={handleperhistory} className="form-check-input" />
                                            <label className="form-check-label mr-20" htmlFor="isOralCancerYes">Yes</label>
                                            <input type="radio" name="isOralCancer" id="isOralCancerNo" value="no" checked={perhistoryform.isOralCancer === false} onChange={handleperhistory} className="form-check-input" />
                                            <label className="form-check-label" htmlFor="isOralCancerNo">No</label>
                                            {formErrors.isOralCancer && <p className="error">{formErrors.isOralCancer}</p>}
                                        </td>
                                        <td className="radio_color">
                                            <input type="radio" name="isOralCancerUnderTreatment" id="isOralCancerUnderTreatmentYes" value="yes" checked={perhistoryform.isOralCancerUnderTreatment === true} onChange={handleperhistory} disabled={!perhistoryform.isOralCancer} className="form-check-input" />
                                            <label className="form-check-label mr-20" htmlFor="isOralCancerUnderTreatmentYes">Yes</label>
                                            <input type="radio" name="isOralCancerUnderTreatment" id="isOralCancerUnderTreatmentNo" value="no" checked={perhistoryform.isOralCancerUnderTreatment === false} onChange={handleperhistory} disabled={!perhistoryform.isOralCancer} className="form-check-input" />
                                            <label className="form-check-label" htmlFor="isOralCancerUnderTreatmentNo">No</label>
                                            {formErrors.isOralCancerUnderTreatment && <p className="error">{formErrors.isOralCancerUnderTreatment}</p>}
                                        </td>
                                    </tr>
                                    {/* Show Breast and Cervical Cancer only for female */}
                                    {gender?.toLowerCase() === 'female' && (
                                        <>
                                            <tr>
                                                <td>Breast Cancer </td>
                                                <td className="radio_color">
                                                    <input type="radio" name="isBreastCancer" id="isBreastCancerYes" value="yes" checked={perhistoryform.isBreastCancer === true} onChange={handleperhistory} className="form-check-input" />
                                                    <label className="form-check-label mr-20" htmlFor="isBreastCancerYes">Yes</label>
                                                    <input type="radio" name="isBreastCancer" id="isBreastCancerNo" value="no" checked={perhistoryform.isBreastCancer === false} onChange={handleperhistory} className="form-check-input" />
                                                    <label className="form-check-label" htmlFor="isBreastCancerNo">No</label>
                                                    {formErrors.isBreastCancer && <p className="error">{formErrors.isBreastCancer}</p>}
                                                </td>
                                                <td className="radio_color">
                                                    <input type="radio" name="isBreastCancerUnderTreatment" id="isBreastCancerUnderTreatmentYes" value="yes" checked={perhistoryform.isBreastCancerUnderTreatment === true} onChange={handleperhistory} disabled={!perhistoryform.isBreastCancer} className="form-check-input" />
                                                    <label className="form-check-label mr-20" htmlFor="isBreastCancerUnderTreatmentYes">Yes</label>
                                                    <input type="radio" name="isBreastCancerUnderTreatment" id="isBreastCancerUnderTreatmentNo" value="no" checked={perhistoryform.isBreastCancerUnderTreatment === false} onChange={handleperhistory} disabled={!perhistoryform.isBreastCancer} className="form-check-input" />
                                                    <label className="form-check-label" htmlFor="isBreastCancerUnderTreatmentNo">No</label>
                                                    {formErrors.isBreastCancerUnderTreatment && <p className="error">{formErrors.isBreastCancerUnderTreatment}</p>}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Cervical Cancer </td>
                                                <td className="radio_color">
                                                    <input type="radio" name="isCervicalCancer" id="isCervicalCancerYes" value="yes" checked={perhistoryform.isCervicalCancer === true} onChange={handleperhistory} className="form-check-input" />
                                                    <label className="form-check-label mr-20" htmlFor="isCervicalCancerYes">Yes</label>
                                                    <input type="radio" name="isCervicalCancer" id="isCervicalCancerNo" value="no" checked={perhistoryform.isCervicalCancer === false} onChange={handleperhistory} className="form-check-input" />
                                                    <label className="form-check-label" htmlFor="isCervicalCancerNo">No</label>
                                                    {formErrors.isCervicalCancer && <p className="error">{formErrors.isCervicalCancer}</p>}
                                                </td>
                                                <td className="radio_color">
                                                    <input type="radio" name="isCervicalCancerUnderTreatment" id="isCervicalCancerUnderTreatmentYes" value="yes" checked={perhistoryform.isCervicalCancerUnderTreatment === true} onChange={handleperhistory} disabled={!perhistoryform.isCervicalCancer} className="form-check-input" />
                                                    <label className="form-check-label mr-20" htmlFor="isCervicalCancerUnderTreatmentYes">Yes</label>
                                                    <input type="radio" name="isCervicalCancerUnderTreatment" id="isCervicalCancerUnderTreatmentNo" value="no" checked={perhistoryform.isCervicalCancerUnderTreatment === false} onChange={handleperhistory} disabled={!perhistoryform.isCervicalCancer} className="form-check-input" />
                                                    <label className="form-check-label" htmlFor="isCervicalCancerUnderTreatmentNo">No</label>
                                                    {formErrors.isCervicalCancerUnderTreatment && <p className="error">{formErrors.isCervicalCancerUnderTreatment}</p>}
                                                </td>
                                            </tr>
                                        </>
                                    )}
                                    <tr>
                                        <td>If Others, Specify
                                            <input type="text" className="exam-textarea" name="otherDiseaseDetails" onChange={handleperhistory} ></input>
                                        </td>
                                        <td className="radio_color">
                                            <input type="radio" name="isOtherDisease" id="isOtherDiseaseYes" value="yes" checked={perhistoryform.isOtherDisease === true} onChange={handleperhistory} disabled={!perhistoryform.otherDiseaseDetails?.trim()} className="form-check-input" />
                                            <label className="form-check-label mr-20" htmlFor="isOtherDiseaseYes">Yes</label>
                                            <input type="radio" name="isOtherDisease" id="isOtherDiseaseNo" value="no" checked={perhistoryform.isOtherDisease === false} onChange={handleperhistory} disabled={!perhistoryform.otherDiseaseDetails?.trim()} className="form-check-input" />
                                            <label className="form-check-label" htmlFor="isOtherDiseaseNo">No</label>
                                            {formErrors.isOtherDisease && <p className="error">{formErrors.isOtherDisease}</p>}
                                        </td>
                                        <td className="radio_color">
                                            <input type="radio" name="isOtherDiseaseUnderTreatment" id="isOtherDiseaseUnderTreatmentYes" value="yes" checked={perhistoryform.isOtherDiseaseUnderTreatment === true} onChange={handleperhistory} disabled={!perhistoryform.isOtherDisease} className="form-check-input" />
                                            <label className="form-check-label mr-20" htmlFor="isOtherDiseaseUnderTreatmentYes">Yes</label>
                                            <input type="radio" name="isOtherDiseaseUnderTreatment" id="isOtherDiseaseUnderTreatmentNo" value="no" checked={perhistoryform.isOtherDiseaseUnderTreatment === false} onChange={handleperhistory} disabled={!perhistoryform.isOtherDisease} className="form-check-input" />
                                            <label className="form-check-label" htmlFor="isOtherDiseaseUnderTreatmentNo">No</label>
                                            {formErrors.isOtherDiseaseUnderTreatment && <p className="error">{formErrors.isOtherDiseaseUnderTreatment}</p>}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            {/* Menstrual History only for female */}
                            {gender?.toLowerCase() === 'female' && (
                                <>
                                    <h4>Menstrual History</h4>
                                    <div className="MenstrualHistory d-flex justify-content-between align-items-center">
                                        <div className="exam-item">
                                            <span className="exam-label">Age at menarche </span>
                                            <input
                                                type="text"
                                                className="exam-textarea"
                                                name="menarcheAge"
                                                value={menstrualForm.menarcheAge}
                                                onChange={handleMenstrualChange}
                                            />
                                        </div>
                                        <div className="fields exam-item">
                                            <label className="mx-2">Menopause</label>
                                            <div className="radioYesNo">
                                                <label className="d-flex align-items-center gap-1">
                                                    <input
                                                        type="radio"
                                                        name="isMenopause"
                                                        value="yes"
                                                        checked={menstrualForm.isMenopause === true}
                                                        onChange={handleMenstrualChange}
                                                        disabled={menstrualForm.isPregnant === true}
                                                        className="form-check-input"
                                                    />
                                                    <span className="checkmark"></span>
                                                    Yes
                                                </label>
                                                <label className="d-flex align-items-center gap-1">
                                                    <input
                                                        type="radio"
                                                        name="isMenopause"
                                                        value="no"
                                                        checked={menstrualForm.isMenopause === false}
                                                        onChange={handleMenstrualChange}
                                                        disabled={menstrualForm.isPregnant === true}
                                                        className="form-check-input"
                                                    />
                                                    <span className="checkmark"></span>
                                                    No
                                                </label>
                                            </div>
                                        </div>
                                        <div className="exam-item">
                                            <span className="exam-label">Duration of menopause <span className="text-danger">*</span></span>
                                            <div className="d-flex align-items-center gap-2">
                                                <Form.Control
                                                    type="text"
                                                    placeholder="0"
                                                    name="menopauseDurationYear"
                                                    value={menstrualForm.menopauseDurationYear || ""}
                                                    onChange={handleMenstrualChange}
                                                    className="exam-textarea"
                                                    style={{ width: '50px', height: "30px" }}
                                                    disabled={menstrualForm.isMenopause !== true || menstrualForm.isPregnant === true}
                                                />
                                                <span>Year</span>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="0"
                                                    name="menopauseDurationMonth"
                                                    value={menstrualForm.menopauseDurationMonth || ""}
                                                    onChange={handleMenstrualChange}
                                                    className="exam-textarea"
                                                    style={{ width: '50px', height: "30px" }}
                                                    disabled={menstrualForm.isMenopause !== true || menstrualForm.isPregnant === true}
                                                />
                                                <span>Month</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="MenstrualHistory d-flex justify-content-between align-items-center mt-2">
                                        <div className="fields exam-item">
                                            <label className="mx-2">Pregnant</label>
                                            <div className="radioYesNo">
                                                <label className="d-flex align-items-center gap-1">
                                                    <input
                                                        type="radio"
                                                        name="isPregnant"
                                                        value="yes"
                                                        checked={menstrualForm.isPregnant === true}
                                                        onChange={handleMenstrualChange}
                                                        disabled={menstrualForm.isMenopause === true}
                                                        className="form-check-input"
                                                    />
                                                    <span className="checkmark"></span>
                                                    Yes
                                                </label>
                                                <label className="d-flex align-items-center gap-1">
                                                    <input
                                                        type="radio"
                                                        name="isPregnant"
                                                        value="no"
                                                        checked={menstrualForm.isPregnant === false}
                                                        onChange={handleMenstrualChange}
                                                        disabled={menstrualForm.isMenopause === true}
                                                        className="form-check-input"
                                                    />
                                                    <span className="checkmark"></span>
                                                    No
                                                </label>
                                            </div>
                                        </div>
                                        <div className="fields exam-item">
                                            <label className="mx-2">Lactating</label>
                                            <div className="radioYesNo">
                                                <label className="d-flex align-items-center gap-1">
                                                    <input
                                                        type="radio"
                                                        name="isLactating"
                                                        value="yes"
                                                        checked={menstrualForm.isLactating === true}
                                                        onChange={handleMenstrualChange}
                                                        disabled={menstrualForm.isMenopause === true}
                                                        className="form-check-input"
                                                    />
                                                    <span className="checkmark"></span>
                                                    Yes
                                                </label>
                                                <label className="d-flex align-items-center gap-1">
                                                    <input
                                                        type="radio"
                                                        name="isLactating"
                                                        value="no"
                                                        checked={menstrualForm.isLactating === false}
                                                        onChange={handleMenstrualChange}
                                                        disabled={menstrualForm.isMenopause === true}
                                                        className="form-check-input"
                                                    />
                                                    <span className="checkmark"></span>
                                                    No
                                                </label>
                                            </div>
                                        </div>
                                        <div className="fields exam-item">
                                            <label className="mx-2">Regular periods</label>
                                            <div className="radioYesNo">
                                                <label className="d-flex align-items-center gap-1">
                                                    <input
                                                        type="radio"
                                                        name="isRegularPeriods"
                                                        value="yes"
                                                        checked={menstrualForm.isRegularPeriods === true}
                                                        onChange={handleMenstrualChange}
                                                        disabled={menstrualForm.isMenopause === true || menstrualForm.isPregnant === true}
                                                        className="form-check-input"
                                                    />
                                                    <span className="checkmark"></span>
                                                    Yes
                                                </label>
                                                <label className="d-flex align-items-center gap-1">
                                                    <input
                                                        type="radio"
                                                        name="isRegularPeriods"
                                                        value="no"
                                                        checked={menstrualForm.isRegularPeriods === false}
                                                        onChange={handleMenstrualChange}
                                                        disabled={menstrualForm.isMenopause === true || menstrualForm.isPregnant === true}
                                                        className="form-check-input"
                                                    />
                                                    <span className="checkmark"></span>
                                                    No
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex flex-wrap justify-content-between align-items-start gap-3 mt-2">
                                        <div className="exam-item">
                                            <span className="exam-label">Last Menstrual Period <span className="text-danger">*</span></span>
                                            <input
                                                type="date"
                                                className="exam-textarea"
                                                name="lastMenstrualDate"
                                                value={
                                                    menstrualForm.lastMenstrualDate
                                                        ? (() => {
                                                            const parts = menstrualForm.lastMenstrualDate.split("-");
                                                            if (parts.length === 3 && parts[2].length === 4) {
                                                                return `${parts[2]}-${parts[1]}-${parts[0]}`;
                                                            }
                                                            return menstrualForm.lastMenstrualDate;
                                                        })()
                                                        : ""
                                                }
                                                onChange={handleMenstrualChange}
                                                disabled={
                                                    menstrualForm.isMenopause === true ||
                                                    menstrualForm.isPregnant === true ||
                                                    menstrualForm.isLactating === true
                                                }
                                            />
                                        </div>
                                        <div className="fields exam-item">
                                            <label className="mx-2">Bleeding</label>
                                            <div className="radioYesNo">
                                                <label className="d-flex align-items-center gap-1">
                                                    <input
                                                        type="radio"
                                                        name="menstrualBleedingType"
                                                        value="heavy"
                                                        checked={menstrualForm.menstrualBleedingType === "heavy"}
                                                        onChange={handleMenstrualChange}
                                                        disabled={menstrualForm.isMenopause === true || menstrualForm.isPregnant === true}
                                                        className="form-check-input"
                                                    />
                                                    <span className="checkmark"></span>
                                                    Heavy
                                                </label>
                                                <label className="d-flex align-items-center gap-1">
                                                    <input
                                                        type="radio"
                                                        name="menstrualBleedingType"
                                                        value="normal"
                                                        checked={menstrualForm.menstrualBleedingType === "normal"}
                                                        onChange={handleMenstrualChange}
                                                        disabled={menstrualForm.isMenopause === true || menstrualForm.isPregnant === true}
                                                        className="form-check-input"
                                                    />
                                                    <span className="checkmark"></span>
                                                    Normal
                                                </label>
                                            </div>
                                        </div>
                                        {/* Checkboxes (Left side) */}
                                        <div className="exam-item flex-grow-1" style={{ flexBasis: '30%' }}>
                                            <span className="exam-label">
                                                Associated with <span className="text-danger">*</span>
                                            </span>
                                            <div className="d-flex gap-4 mt-2">
                                                <label className="d-flex align-items-center gap-1">
                                                    <input
                                                        type="checkbox"
                                                        name="isBleedingWithClots"
                                                        checked={!!menstrualForm.isBleedingWithClots}
                                                        onChange={handleMenstrualChange}
                                                        disabled={menstrualForm.isMenopause === true || menstrualForm.isPregnant === true}
                                                    />
                                                    <span>Clots</span>
                                                </label>
                                                <label className="d-flex align-items-center gap-1">
                                                    <input
                                                        type="checkbox"
                                                        name="isBleedingWithPain"
                                                        checked={!!menstrualForm.isBleedingWithPain}
                                                        onChange={handleMenstrualChange}
                                                        disabled={menstrualForm.isMenopause === true || menstrualForm.isPregnant === true}
                                                    />
                                                    <span>Pain</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex flex-wrap align-items-start gap-3 mt-2">
                                        <div className="exam-item flex-grow-1" style={{ flexBasis: '67%' }}>
                                            <span className="exam-label">Remarks</span>
                                            <input
                                                type="text"
                                                className="form-control mt-2"
                                                name="remarks"
                                                value={menstrualForm.remarks}
                                                onChange={handleMenstrualChange}
                                                placeholder="Enter remarks"
                                                style={{ width: '100%', height: "30px" }}
                                            />
                                        </div>
                                    </div>
                                </>
                            )}

                            <div className="save-button-container">
                                <button type="submit" className="save-button">Save</button>
                            </div>

                        </form>
                    </div>
                ) : (
                    <>
                        <div className="table-responsive">
                            <table className="table custom-striped custom-table">
                                <thead className="table-head">
                                    <tr>
                                        <th>Disease</th>
                                        <th>Ever Diagnosed</th>
                                        <th>Under Treatment</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {personalhistory && Object.keys(personalhistory).length > 0 ? (
                                        <>
                                            <tr>
                                                <td>Hypertension</td>
                                                <td className="radio_color ">{personalhistory?.isHypertension ? "Yes" : "No"}</td>
                                                <td className="radio_color ">{personalhistory?.isHypertensionUnderTreatment ? "Yes" : "No"}</td>
                                            </tr>
                                            <tr>
                                                <td>Diabetes</td>
                                                <td className="radio_color">{personalhistory?.isDiabetes ? "Yes" : "No"}</td>
                                                <td className="radio_color">{personalhistory?.isDiabetesUnderTreatment ? "Yes" : "No"}</td>
                                            </tr>
                                            <tr>
                                                <td>Heart Disease</td>
                                                <td className="radio_color">{personalhistory?.isHeartDiseases ? "Yes" : "No"}</td>
                                                <td className="radio_color">{personalhistory?.isHeartDiseasesUnderTreatment ? "Yes" : "No"}</td>
                                            </tr>
                                            <tr>
                                                <td>Stroke</td>
                                                <td className="radio_color">{personalhistory?.isStroke ? "Yes" : "No"}</td>
                                                <td className="radio_color">{personalhistory?.isStrokeUnderTreatment ? "Yes" : "No"}</td>
                                            </tr>
                                            <tr>
                                                <td>Kidney failure</td>
                                                <td className="radio_color">{personalhistory?.isKidneyFailure ? "Yes" : "No"}</td>
                                                <td className="radio_color">{personalhistory?.isKidneyFailureUnderTreatment ? "Yes" : "No"}</td>
                                            </tr>
                                            <tr>
                                                <td>Non-healing Wound</td>
                                                <td className="radio_color">{personalhistory?.isNonHealingWounds ? "Yes" : "No"}</td>
                                                <td className="radio_color">{personalhistory?.isNonHealingWoundsUnderTreatment ? "Yes" : "No"}</td>
                                            </tr>
                                            <tr>
                                                <td>COPD</td>
                                                <td className="radio_color">{personalhistory?.isCopd ? "Yes" : "No"}</td>
                                                <td className="radio_color">{personalhistory?.isCopdUnderTreatment ? "Yes" : "No"}</td>
                                            </tr>
                                            <tr>
                                                <td>Asthma</td>
                                                <td className="radio_color">{personalhistory?.isAsthma ? "Yes" : "No"}</td>
                                                <td className="radio_color">{personalhistory?.isAsthmaUnderTreatment ? "Yes" : "No"}</td>
                                            </tr>
                                            <tr>
                                                <td>Oral Cancer</td>
                                                <td className="radio_color">{personalhistory?.isOralCancer ? "Yes" : "No"}</td>
                                                <td className="radio_color">{personalhistory?.isOralCancerUnderTreatment ? "Yes" : "No"}</td>
                                            </tr>
                                            {/* Show Breast and Cervical Cancer only for female */}
                                            {gender?.toLowerCase() === 'female' && (
                                                <>
                                                    <tr>
                                                        <td>Breast Cancer</td>
                                                        <td className="radio_color">{personalhistory?.isBreastCancer ? "Yes" : "No"}</td>
                                                        <td className="radio_color">{personalhistory?.isBreastCancerUnderTreatment ? "Yes" : "No"}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Cervical Cancer</td>
                                                        <td className="radio_color">{personalhistory?.isCervicalCancer ? "Yes" : "No"}</td>
                                                        <td className="radio_color">{personalhistory?.isCervicalCancerUnderTreatment ? "Yes" : "No"}</td>
                                                    </tr>
                                                </>
                                            )}

                                            <tr>
                                                <td>If others, specify
                                                    <input type="text" className="exam-textarea" name="otherDiseaseDetails" value={personalhistory?.otherDiseaseDetails || ''} readOnly />
                                                </td>
                                                <td className="radio_color">{personalhistory?.isOtherDisease ? "Yes" : "No"}</td>
                                                <td className="radio_color">{personalhistory?.isOtherDiseaseUnderTreatment ? "Yes" : "No"}</td>
                                            </tr>
                                        </>
                                    ) : (
                                        <tr>
                                            <td colSpan="3" className="text-center">No record found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {menstrualHistory && gender?.toLowerCase() === 'female' && (
                            <div className="table-responsive">
                                <table className="table custom-striped custom-table">
                                    <tbody>
                                        <tr>
                                            <td>Age at menarche</td>
                                            <td>{menstrualHistory.menarcheAge || "-"}</td>
                                        </tr>
                                        <tr>
                                            <td>Menopause</td>
                                            <td>{menstrualHistory.isMenopause === true ? "Yes" : menstrualHistory.isMenopause === false ? "No" : "-"}</td>
                                        </tr>
                                        <tr>
                                            <td>Duration of menopause</td>
                                            <td>{menstrualHistory.menopauseDuration || "-"}</td>
                                        </tr>
                                        <tr>
                                            <td>Pregnant</td>
                                            <td>{menstrualHistory.isPregnant === true ? "Yes" : menstrualHistory.isPregnant === false ? "No" : "-"}</td>
                                        </tr>
                                        <tr>
                                            <td>Lactating</td>
                                            <td>{menstrualHistory.isLactating === true ? "Yes" : menstrualHistory.isLactating === false ? "No" : "-"}</td>
                                        </tr>
                                        <tr>
                                            <td>Regular periods</td>
                                            <td>{menstrualHistory.isRegularPeriods === true ? "Yes" : menstrualHistory.isRegularPeriods === false ? "No" : "-"}</td>
                                        </tr>
                                        <tr>
                                            <td>Last Menstrual Period</td>
                                            <td>{menstrualHistory.lastMenstrualDate || "-"}</td>
                                        </tr>
                                        <tr>
                                            <td>Bleeding</td>
                                            <td>
                                                {menstrualHistory.isMenstrualBleedingHeavy === true
                                                    ? "Heavy"
                                                    : menstrualHistory.isMenstrualBleedingNormal === true
                                                        ? "Normal"
                                                        : "-"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Associated with</td>
                                            <td>
                                                {menstrualHistory.isBleedingWithClots ? "Clots" : ""}
                                                {menstrualHistory.isBleedingWithClots && menstrualHistory.isBleedingWithPain ? ", " : ""}
                                                {menstrualHistory.isBleedingWithPain ? "Pain" : ""}
                                                {(!menstrualHistory.isBleedingWithClots && !menstrualHistory.isBleedingWithPain) ? "-" : ""}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Remarks</td>
                                            <td>{menstrualHistory.remarks || "-"}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </>
                )}
            </div>

            <div className="separator"></div>
        </>
    );
};
